import React from "react";
import { useNavigate } from "react-router-dom";
import AddPrescriptionForm from "./AddPrescriptionForm";

const PrescriptionPage = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    // Navigate back to the previous page or to home if no history
    navigate(-1);
  };

  return <AddPrescriptionForm onClose={handleClose} />;
};

export default PrescriptionPage;